<form [formGroup]="table">
    <mat-form-field>
        <mat-label>Page Sizes</mat-label>
        <input matInput formControlName="PageSizeOptions">
    </mat-form-field>
    <div>
        <div class="columns">
            <app-column *ngFor="let col of Columns.controls; index as i" 
            [column]="col" 
            [index]="i" 
            [fieldlist]="fieldList"></app-column>
        </div>
    </div>
</form>
